<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color" style="background-color: #1e4374">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/logoSACTransparente.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4 flex">
                  <h4 class="mb-6">Acesso</h4>
                  <p class="ml-auto text-xs font-medium">v. {{VERSAO}} </p>                   
                </div>

                <div>
                  <vs-input
                      name="login"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      label-placeholder="Login"
                      @keyup.enter="efetuarLogin()"
                      v-model="login"
                      class="w-full"/>

                  <vs-input
                      type="password"
                      name="senha"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="Senha"
                      @keyup.enter="efetuarLogin()"
                      v-model="senha"
                      class="w-full mt-6" />

                  <div ref="captcha" class="mt-6"></div>
                  
                  <div class="flex justify-between my-5 items-center">
                      <vs-button @click="efetuarLogin">ENTRAR</vs-button>
                      
                        <a :href="linkWhatsapp"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="flex items-center"
                          style="color: #25D366; text-decoration: none;">
                          <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
                            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488"/>
                          </svg>
                          <span class="ml-2 text-sm font-medium">Falar com o suporte</span>
                        </a>
                      
                  </div>
                 
                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default{
  data() {
    return {
      login: "",
      senha: "",      
      captchaToken: "",
      captchaWidgetId: null,
      publicPath: process.env.BASE_URL,
    }
  },
  created(){
      this.VERSAO = process.env.VUE_APP_NUMERO_VERSAO
  },
  computed: {
    linkWhatsapp() {
      return 'https://wa.me/558633011878?text=' + encodeURIComponent('Olá, preciso de suporte no SAC.');
    },
  },
  methods: {
      efetuarLogin() {      
        if (!this.captchaToken) {
          this.$vs.notify({
            title: "Atenção",
            text: "Confirme o captcha antes de entrar",
            iconPack: 'feather', icon: 'icon-alert-circle', color: 'warning'
          });
          return;
        }
        const params = new URLSearchParams();        
        params.append('cpf', this.login);
        params.append('senha', this.senha);
        params.append('captchaToken', this.captchaToken);
                
        this.$vs.loading();

        let currentObj = this;
        
        this.$http.post('/Usuario/ValidarUsuario', 
            params, { headers: {'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'}
        }).then(function (response) {
            currentObj.$vs.loading.close();
            
            if (response.data.Usuario.id && response.data.Usuario.id !== 0) {   
                localStorage.login = currentObj.login;
                currentObj.$store.commit("SALVAR_USUARIO_LOGADO", response.data.Usuario);   
                if ((currentObj.$store.state.AppActiveUser.perfil === 'GESTOR') || (currentObj.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') || (currentObj.$store.state.AppActiveUser.perfil === 'FINANCEIRO')) {
                  currentObj.$router.push({ path: '/home' })
                } else if (currentObj.$store.state.AppActiveUser.perfil === 'CRM_CONTA_RECEBER' || currentObj.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_RECEBER') {
                  currentObj.$router.push({ path: '/financeiro/contas-a-receber/pesquisar' })
                } else if (currentObj.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_PAGAR') {
                  currentObj.$router.push({ path: '/financeiro/contas-a-pagar/pesquisar' })
                } else if (currentObj.$store.state.AppActiveUser.perfil === 'COMPRAS') {
                  currentObj.$router.push({ path: '/financeiro/compras/pesquisar' })
                } else if (currentObj.$store.state.AppActiveUser.perfil === 'CRM') {
                  currentObj.$router.push({ path: '/cadastro/favorecidos/pesquisar' })
                }
            } else {                	          
              currentObj.captchaToken = "";  
              currentObj.$vs.notify({ 
                title: "Erro", text: "Acesso Inválido",  iconPack: 'feather', icon: 'icon-alert-circle', color: 'danger'  });
            }
            
        }).catch(function () {
            currentObj.$vs.loading.close();
            currentObj.captchaToken = "";
            currentObj.$vs.notify({
                    title: "Erro",
                    text: "Erro no acesso",
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                  });
        });

      },
      carregarCaptcha() {
        if (window.turnstile && window.turnstile.render) {
          this.renderizarCaptcha();
          return;
        }
        window.onCaptchaLoad = () => this.renderizarCaptcha();
        const s = document.createElement('script');
        s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onCaptchaLoad&render=explicit';
        s.async = true;
        s.defer = true;
        document.head.appendChild(s);
      },
      renderizarCaptcha() {
        this.captchaWidgetId = window.turnstile.render(this.$refs.captcha, {
          sitekey: process.env.VUE_APP_CAPTCHA_SITE_KEY,
          callback: (token) => { this.captchaToken = token; },
          'expired-callback': () => { this.captchaToken = ""; },
          'error-callback': () => { this.captchaToken = ""; }
        });
      },
  } ,
  mounted() {
    this.carregarCaptcha();
  },
  beforeDestroy(){
      if (this.captchaWidgetId !== null && window.turnstile) {
          window.turnstile.remove(this.captchaWidgetId);
      }
  },
}
</script>
